import * as React from 'react';
import Icons from '@/const/icons';
import { Typography } from '@/components/common';
import { IconBox } from '@/components/common/icon-box';
import clsx from 'clsx';
import { ActionRequiredResult } from '@/interfaces';

export const CaseMetricsActionRequired = ({
	actionRequired,
}: {
	actionRequired: ActionRequiredResult[];
}) => {
	const options = [
		{
			title: 'Action Required Lawyer',
			id: 'action-required-lawyer',
			icon: Icons.userEdit,
			amount: actionRequired[0]?.action_required_lawyer || '0',
			bgColor: 'bg-[#3957F429]',
			textColor: 'text-main-blue-dark',
		},
		{
			title: 'Action Required Client',
			id: 'action-required-client',
			icon: Icons.userOctagon,
			amount: actionRequired[0]?.action_required_client || '0',
			bgColor: 'bg-[#EB35CE29]',
			textColor: 'text-main-magenta',
		},
		{
			title: 'Number of New Emails',
			id: 'number-new-emails',
			icon: Icons.sms,
			amount: actionRequired[0]?.new_emails || '0',
			bgColor: 'bg-[#F6C64A29]',
			textColor: 'text-main-yellow',
		},
	];
	return (
		<div>
			<ul className="px-4 lg:pl-4 lg:pr-8 2xl:pr-14 mt-3">
				{options.map((item, index) => (
					<li
						key={item.id}
						className={clsx('flex items-center w-full justify-between pb-7', {
							'border-b border-[#0D061614] mb-7': index < options.length - 1,
						})}
					>
						<div className="flex items-center gap-3">
							<IconBox
								bgColor={item.bgColor}
								icon={item.icon}
								size="small"
								textColor={item.textColor}
							/>
							<Typography
								type="semibold-12"
								className="text-grey-80 max-w-[98px] sm:max-w-full lg:max-w-[98px] text-start"
							>
								{item.title}
							</Typography>
						</div>
						<Typography
							type="semibold-20"
							className="text-grey-90 px-2 !text-[20px] !leading-[24px]"
						>
							{item.amount}
						</Typography>
					</li>
				))}
			</ul>
		</div>
	);
};
